// useLayers — guarded access to the layers context (US-875 · AC-3/AC-7).
import { useContext } from "react";
import { LayersContext } from "../contexts/LayersContext";

const useLayers = () => {
  const ctx = useContext(LayersContext);
  if (ctx === null) {
    throw new Error("useLayers must be used within a <LayersProvider>.");
  }
  return ctx;
};

export default useLayers;
